module.exports = __webpack_public_path__ + "img/cloud-sun.e19fc61e.svg";